import {Button, Checkbox} from 'antd';
import React from "react";
import {
  faviconDynamicFunction,
  getColumnSearchProps,
  getRenderForFieldByType,
  sanitizeFieldName
} from "../../util/methods";
import {
  cancelTpw,
  clearProps,
  createResource,
  fetchQuotations,
  fetchTpwNo,
  saveResourceQuery,
  workDone
} from "../../appRedux/actions/ThirdPartyWorkApproval";
import {fetchFilter, fetchMasterFilter} from "../../appRedux/actions";
import {fetchResource} from "../../appRedux/actions/ThirdPartyWorkQuotation";
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";
import Create from "../ThirdPartyWorkApproval/create";
import AccessControl from "../../components/AccessControl";

class ThirdPartyWorkApproval extends React.Component {

  initialQueryState = {
    sort: {
      field: '',
      order: ''
    },
    pagination: {
      pageSize: 10,
      current: 1
    },
    filters: {},
  };

  state = {
    fields: {
      name: {
        value: '',
      },
      description: {
        value: ''
      }
    },
    query: this.initialQueryState,
    columns: [],
    checked: [],
    checkedAll: false,
    id: null,
    tpwNO: '',
    visible: false,
  };

  componentDidMount() {
    this.props.fetchFilter('ThirdPartyWorkQuotation');
  }

  changeChecked = () => {
    this.setState({checked: []});
  }

  fetchTpwNo = (tpwSearchQuery) => {
    const data = {
      tpwSearchQuery: tpwSearchQuery,
    };
    this.props.fetchTpwNo(data);
  }

  handleFormChange = (changedFields) => {
    this.setState(({fields}) => ({
      fields: {...fields, ...changedFields},
    }));
  };

  fetchQuotations = (values) => {
    this.setState({tpwNO: values});
    this.props.fetchQuotations(values);
   }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters._id && this.props.filters._id !== nextProps.filters._id) {
      const columns = Object.keys(nextProps.filters).filter((filter) =>
        Boolean(nextProps.filters[filter].options && nextProps.filters[filter].options.column));
        this.renderColumns(nextProps.filters, columns);
    }
  }

  handleChange = (pagination, filters, sorter) => {
    const query = {...this.props.query};
    query.pagination = {...query.pagination, current: pagination.current};
    query.sort = sorter;

    this.props.saveResourceQuery(query);
    this.props.fetchQuotations(this.state.tpwNO);
  };

  createResource = (values) => {
    this.props.createResource(values);
  };

  edit = (id) => {
    const {quoteData, quoteFilters} = this.props;
    this.props.fetchResource(id);
    this.props.fetchMasterFilter('ThirdPartyWorkQuotation');
    this.setState({visible:true});

    //const {match} = this.props;
    //this.props.history.push(`third-party-work-quotation/edit/${id}`);
  };

  onClick = (e, id, index) => {
    let check = [];
    if(e.target.checked) {
      check[index] = e.target.checked;
      this.setState({checked: check, id : id});
    } else {
      check[index] = false;
      this.setState({checked: check, id: null});
    }
  }

   handleFilter = (selectedKeys, confirm, data) => {
    const query = {...this.props.query};
    query.filters[data.field] = JSON.stringify({
      value: selectedKeys,
      type: data.type,
      field: data.field
    });
    this.props.saveResourceQuery(query);
    confirm();
    this.props.fetchQuotations(this.state.tpwNO);
  };

  handleModalCancel = e => {
      this.setState({
        visible: false,
      });
    };

  handleReset = (clearFilters, data) => {
    const query = {...this.props.query};
    delete query.filters[data.field];
    this.props.saveResourceQuery(query);
    clearFilters();
    this.props.fetchQuotations(this.state.tpwNO);
  };

  renderColumns = (filters, selectedColumns) => {
    filters = filters || this.props.filters;
    const columns = [];
    const {resourceName} = this.props;

    columns.push({
      title: 'Approve',
      dataIndex: 'approve',
      render: (values, record, index) => <Checkbox style={{marginLeft:'15px'}}
                                                   onClick={ (e) => {this.onClick(e, record._id, index) }}
                                                   checked= {this.state.checked && this.state.checked[index] ? this.state.checked[index] :
                                                     record && record.status && record.status === 'Approved' ? true : false }
                                                    disabled={this.props && this.props.disable}>
                                          </Checkbox>

    });

    Object.keys(filters).forEach((item) => {

      if (item === '_id') {
        return;
      }

      if(item === 'tpwNo' || item === 'date' || item === 'status') {
        return;
      }

      if (selectedColumns.indexOf(item) === -1) {
        return;
      }

      columns.push({
        title: sanitizeFieldName(item),
        dataIndex: filters[item].field,
        sorter: true,
        render: (value) => getRenderForFieldByType(value, filters[item].type, item),
        ...getColumnSearchProps(filters[item], this.handleFilter, this.handleReset, resourceName)
      })
    });

    columns.push({
      title: 'Action',
      key: 'action',
      render: (record) => (
        <div>
          <AccessControl resource={this.props.resourceName} permissionNeeded={'u'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return <Button type="primary" size='small' onClick={() => this.edit(record._id)}>View Quote</Button>
          }}/>
        </div>
      ),
    });
    this.setState({columns});
  }

  render() {
    const {match, resource, loading, filters, modules, authUser, resourceName, disable} = this.props;
    faviconDynamicFunction(authUser);
    return (<div>
      <h2>{sanitizeFieldName(resourceName)}</h2>

      <Switch>
        <Route path={`${match.url}`} exact
               render={(props) => <Create data={{}}
                                          filters={filters}
                                          modules={modules}
                                          title={'CREATE'}
                                          resource={resourceName}
                                          onSubmit={this.createResource}
                                          fetchTpwNo = {this.fetchTpwNo}
                                          onChange = {this.handleFormChange}
                                          fetchQuotations = {this.fetchQuotations}
                                          handleChange={this.handleChange}
                                          tpw = {this.props.tpw}
                                          tpwNo={this.props.tpwNo}
                                          historyData = {this.props.historyData}
                                          clearProps = {this.props.clearProps}
                                          id = {this.state.id}
                                          quotations = {this.props.quotations}
                                          loading={loading}
                                          handleModalCancel = {this.handleModalCancel}
                                          workDone = {this.props.workDone}
                                          columns={this.state.columns}
                                          size={'middle'}
                                          authUser={authUser}
                                          disable = {disable}
                                          changeChecked = {this.changeChecked}
                                          quote = {this.props.quote}
                                          cancelTpw = {this.props.cancelTpw}
                                          visible =  {this.state.visible}
                                          quoteData = {this.props.quoteData}
                                          quoteFilters = {this.props.quoteFilters}
                                          {...props}
               />
               }/>
      </Switch>
    </div>)
  }
}
const mapStateToProps = ({auth, thirdPartyWorkApproval, thirdPartyWorkQuotation, commonData}) => {
  return {
    authUser: auth.authUser,
    total: thirdPartyWorkApproval.total,
    resource: thirdPartyWorkApproval.resource,
    query: thirdPartyWorkApproval.query,
    loading: commonData.loading,
    filters: commonData.filters,
    quoteData : thirdPartyWorkQuotation.edit,
    quoteFilters: commonData.masterFilters,
    modules: commonData.modules,
    tpw: thirdPartyWorkApproval.tpwSno,
    quotations: thirdPartyWorkApproval.quotations,
    disable: thirdPartyWorkApproval.disable,
    quote: thirdPartyWorkApproval.quote,
    tpwNo : thirdPartyWorkApproval.tpwNo,
    historyData: thirdPartyWorkApproval.history,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    createResource,
    fetchFilter,
    fetchResource,
    fetchMasterFilter,
    fetchTpwNo,
    fetchQuotations,
    clearProps,
    cancelTpw,
    workDone,
    saveResourceQuery
  };
}
export default connect(mapStateToProps, mapDispatchToProps())(ThirdPartyWorkApproval);

